import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BeatLoader } from 'react-spinners';
import AccessDenied from '../component/pages/accessdenied';


import DigitalSuccessRoomRedirector from '../component/pages/digitalsuccessroomredirector';
import DigitalSuccessRoomUniv from '../component/pages/digitalsuccessroomuniv';
import ProjectPlan from '../component/pages/dsr'

const CustomRoutes = () => {


  return (
      <BrowserRouter>
      <Suspense fallback={ <div style={{ position: 'fixed', top: '350px', left: '800px' }}>
      <BeatLoader color={'#123abc'} loading={true} size={10} />
    </div>}>
        <Routes>

          <Route path="/digitalsuccessroom/:tokenid" element={<DigitalSuccessRoomRedirector />} />
          <Route path="/digitalsuccessroominviteduniv/:dsrtokenid" element={<DigitalSuccessRoomUniv />} />
          <Route path="/" element={<AccessDenied />} />

          <Route path="/dsr" element={<ProjectPlan />} />


          {/* 

          <Route  path="/digitalsuccessroom/:loginIduser/:companyid" element={<DigitalSuccessRoom />}  />

          <Route  path="/digitalsuccessroom/:loginIduser/:companyid/:userid" element={<DigitalSuccessRoom />}  />

          <Route  path="/digitalsuccessroominvitededit/:loginIduser/:companyid/:userid" element={<DigitalSuccessRoom />}  />
          <Route  path="/digitalsuccessroominvitedview/:loginIduser/:companyid/:userid" element={<DigitalSuccessRoom />}  />
          <Route  path="/digitalsuccessroominviteduniv/:loginIduser/:companyid" element={<DigitalSuccessRoom />}  />
          */}
        

        </Routes>
        </Suspense>
      </BrowserRouter>
  )
}

export default CustomRoutes